import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { Drug, DrugLight } from "src/app/backend/models/drug";
import { PipesModule } from "src/app/pipes/pipes.module";

@Component({
  standalone: true,
  imports: [TranslocoModule, PipesModule],
  selector: "pms-block-drug",
  templateUrl: "block-drug.component.html",
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ]
})
export class BlockDrugComponent {
  @Input()
  drug: Drug | undefined;

  @Input()
  drugLight: DrugLight | undefined;

  @Input()
  transparent?: boolean;

  @Output()
  select: EventEmitter<void> = new EventEmitter<void>();
}
